import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { FormValidators } from 'src/app/shared/form-error/form.validators';

export function getFormGroup(): UntypedFormGroup {
  return new UntypedFormBuilder().group({
    email: [, [Validators.required, FormValidators.email]],
    password: [, [Validators.required]]
  });
}
